"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGroup = void 0;
const model_1 = require("../../model");
const selectors_1 = require("../../exports/store/selectors");
const interfaces_1 = require("../../exports/store/interfaces");
const types_1 = require("../../types");
const i18n_1 = require("../../exports/i18n");
const command_manager_1 = require("../../command_manager");
exports.setGroup = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data, viewId } = options;
        const datasheetId = (0, selectors_1.getActiveDatasheetId)(state);
        const datasheet = (0, selectors_1.getDatasheet)(state, datasheetId);
        const fieldIds = (0, selectors_1.getCurrentView)(state, datasheetId).columns.map(item => item.fieldId);
        const fieldPermissionMap = (0, selectors_1.getFieldPermissionMap)(state, datasheetId);
        if (!state || !datasheet) {
            return null;
        }
        // Determine whether the currently operating view is the active view
        if (datasheet.activeView !== viewId) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_group_failed_wrong_target_view));
        }
        const checkMissGroupField = () => {
            return data && data.filter(item => {
                // Data missing due to permissions is expected and will not be processed
                if ((0, selectors_1.getFieldRoleByFieldId)(fieldPermissionMap, item.fieldId) === interfaces_1.Role.None) {
                    return false;
                }
                return !fieldIds.includes(item.fieldId);
            }).length;
        };
        // Check if the field used by grouping exists in the current view
        if (checkMissGroupField()) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_group_failed_the_column_not_exist));
        }
        const actions = [];
        const setSortInfoAction = model_1.DatasheetActions.setGroupInfoField2Action(datasheet.snapshot, { viewId, groupInfo: data });
        setSortInfoAction && actions.push(setSortInfoAction);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
//# sourceMappingURL=set_group.js.map